<template>
  <v-main>
    <v-row class="justify-center">
      <v-text-field class="range" v-model="dateRangeText" label="Intervalo" prepend-icon="mdi-calendar" readonly></v-text-field>
      <div class="d-flex align-center" @click="feedDashboard">
        <v-icon class="mx-5" color="primary">mdi-eye</v-icon>
      </div>
    </v-row>
    <v-row class="justify-center my-5">
      <v-date-picker color="#D4AF37" v-model="range" :max="today" selected-items-text="" range></v-date-picker>
    </v-row>
    <v-row class="statistics align-center justify-space-around mt-15 mx-auto">
      <v-card class="d-flex flex-column align-center mt-2" color="primary" dark width="225">
        <v-card-title class="headline">Registrations</v-card-title>
        <v-card-subtitle>{{ newUsers }}</v-card-subtitle>
      </v-card>
      <v-card class="d-flex flex-column align-center" color="primary" dark width="225">
        <v-card-title class="headline">Lists</v-card-title>
        <v-card-subtitle>{{ newLists }}</v-card-subtitle>
      </v-card>
      <v-card class="d-flex flex-column align-center" color="primary" dark width="225">
        <v-card-title class="headline">Orders</v-card-title>
        <v-card-subtitle>{{ ordersCount }} - {{ ordersAmount | brl }}</v-card-subtitle>
      </v-card>
      <v-card class="d-flex flex-column align-center" color="primary" dark width="225">
        <v-card-title class="headline">Services</v-card-title>
        <v-card-subtitle>{{services}}</v-card-subtitle>
      </v-card>
      <v-card class="d-flex flex-column align-center mt-5" color="primary" dark width="225">
        <v-card-title class="headline">Services Amount</v-card-title>
        <v-card-subtitle>{{withdrawals}} - {{ withdrawalsAmount | brl }}</v-card-subtitle>
      </v-card>
      <v-card class="d-flex flex-column align-center mt-5" color="primary" dark width="225">
        <v-card-title class="headline">Withdrawals</v-card-title>
        <v-card-subtitle>{{withdrawals}} - {{ withdrawalsAmount | brl }}</v-card-subtitle>
      </v-card>
    </v-row>
  </v-main>
</template>
<style lang="scss">
  .v-picker { margin: 0 35px 25px; }
  .range { max-width: 250px !important; }
  .v-card__subtitle { font-size: 20px; }
  .statistics { max-width: 1100px; }
</style>
<script>
import Vue from 'vue'

const today = new Date().toISOString().substr(0, 10)

export default Vue.extend({
  name: 'Dashboard',
  data: () => ({
    newUsers: 0,
    newLists: 0,
    services: 0,
    withdrawals: 0,
    withdrawalsAmount: 0,
    lists: [],
    ordersCount: 0,
    ordersAmount: 0,
    today,
    range: [today, today]
  }),
  mounted () {
    this.$store.watch(
      (state) => state,
      (updatedState) => {
        if (updatedState.isAuthenticated) this.feedDashboard()
        if (updatedState.ordersAmount > 0) this.ordersAmount = updatedState.ordersAmount
        if (updatedState.orders.length) this.ordersCount = updatedState.orders.length
      },
      { deep: true }
    )
  },
  computed: {
    dateRangeText () { return this.range.join(' ~ ') }
  },
  methods: {
    feedDashboard () {
      this.getUserCount()
      this.getListCount()
      this.getServicesCount()
      this.getWithDrawalsCountAndAmount()
      this.getOrdersAmount()
    },
    getUserCount () {
      this.$axios.get('user/period', {
        params: {
          beginAt: this.range[0],
          endAt: this.range[1]
        }
      })
        .then(res => this.$set(this, 'newUsers', Object.keys(res.data).length))
        .catch(err => console.log(err))
    },
    getListCount () {
      this.$axios.get('list/period', {
        params: {
          beginAt: this.range[0],
          endAt: this.range[1]
        }
      })
        .then(res => this.$set(this, 'newLists', Object.keys(res.data).length))
        .catch(err => console.log(err))
    },
    getServicesCount () {
      this.$axios.get('list/all/services/count', {
        params: {
          beginAt: this.range[0],
          endAt: this.range[1]
        }
      })
        .then(res => this.$set(this, 'services', res.data))
        .catch(err => console.log(err))
    },
    getWithDrawalsCountAndAmount () {
      this.$axios.get('wallet/withdraw/period', {
        params: {
          status: 'processing',
          beginAt: this.range[0],
          endAt: this.range[1]
        }
      })
        .then(res => {
          this.$set(this, 'withdrawals', Object.keys(res.data).length)
          this.withdrawalsAmount = Number(Object.values(res.data).reduce((sum, withdraw) => sum + withdraw.details.amount, 0))
        })
        .catch(err => console.log(err))
    },
    getOrdersAmount () {
      return this.ordersAmount
    }
  }
})
</script>
